import React, { useState, useEffect } from 'react';
import jsQR from 'jsqr';
import axios from 'axios';

const API = window.location.origin;

const ScanPresencia = () => {
  const [scanResult, setScanResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [fotoCapturada, setFotoCapturada] = useState(null);

  useEffect(() => {
    cargarHistorialHoy();
  }, []);

  const cargarHistorialHoy = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const hoy = new Date().toISOString().split('T')[0];
      
      const resClases = await axios.get(`${API}/api/asistencias`);
      const asistenciasHoy = resClases.data.filter(a => 
        a.estudiante_id === user.id && a.fecha.startsWith(hoy)
      );
      
      const resEventos = await axios.get(`${API}/api/asistencias-eventos`);
      const eventosHoy = resEventos.data.filter(a => 
        a.usuario_id === user.id && a.fecha.startsWith(hoy)
      );
      
      setHistorial([...asistenciasHoy, ...eventosHoy]);
    } catch (error) {
      console.error('Error cargando historial:', error);
    }
  };

  const iniciarScanner = () => {
    console.log('Iniciando cámara...');
    setCameraError(null);
    setScanResult(null);
    setFotoCaptured(null);
    setScanning(true);
    
    setTimeout(() => {
      navigator.mediaDevices.getUserMedia({ 
        video: { 
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        } 
      })
      .then(stream => {
        console.log('Stream obtenido');
        streamRef.current = stream;
        
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.setAttribute('playsinline', '');
          videoRef.current.play().then(() => {
            console.log('Video playing - Listo para capturar');
          }).catch(err => {
            console.error('Error play:', err);
          });
        }
      })
      .catch(error => {
        console.error('Error getUserMedia:', error);
        setCameraError('Error: ' + error.message);
        setScanning(false);
      });
    }, 100);
  };

  const capturarFoto = () => {
    if (!videoRef.current || !canvasRef.current) {
      console.warn('Video o canvas no disponible');
      return;
    }
    
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    if (video.readyState === video.HAVE_ENOUGH_DATA) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      
      // Guardar la imagen capturada
      const imagenCapturada = canvas.toDataURL('image/jpeg', 0.9);
      setFotoCaptured(imagenCapturada);
      
      // Detener el video
      detenerScanner();
      
      // Procesar la imagen con jsQR
      procesarFoto();
    } else {
      alert('⚠️ Espera un momento, la cámara aún está cargando...');
    }
  };

  const procesarFoto = () => {
    setLoading(true);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    
    console.log('🔍 Procesando foto...');
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: 'attemptBoth',
    });
    
    if (code && code.data) {
      console.log('🎉 QR DETECTADO en foto:', code.data);
      procesarQR(code.data);
    } else {
      console.log('❌ No se detectó QR en la foto');
      setLoading(false);
      alert('❌ No se detectó ningún código QR en la foto.\n\nIntenta:\n• Mejor iluminación\n• QR más centrado\n• Más cerca del código');
      // Permitir tomar otra foto
      setFotoCaptured(null);
      iniciarScanner();
    }
  };

  const detenerScanner = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    
    setScanning(false);
  };

  const procesarQR = async (qrData) => {
    setLoading(true);
    console.log('📱 Procesando QR:', qrData);
    
    try {
      // Intentar diferentes formatos de QR
      let tipo, id;
      
      // Formato 1: "tipo|id" (ej: "clase|abc123")
      if (qrData.includes('|')) {
        [tipo, id] = qrData.split('|');
        console.log('Formato tipo|id detectado:', tipo, id);
      }
      // Formato 2: URL completa (ej: "https://domain.com/clase/abc123")
      else if (qrData.includes('/clases/') || qrData.includes('/clase/')) {
        tipo = 'clase';
        id = qrData.split('/').pop();
        console.log('Formato URL clase detectado:', id);
      }
      else if (qrData.includes('/eventos/') || qrData.includes('/evento/')) {
        tipo = 'evento';
        id = qrData.split('/').pop();
        console.log('Formato URL evento detectado:', id);
      }
      // Formato 3: Solo el ID (intentar con clase primero)
      else {
        // Intentar primero como clase
        console.log('Formato solo ID, intentando como clase:', qrData);
        tipo = 'clase';
        id = qrData;
      }
      
      console.log('Intentando marcar asistencia:', tipo, id);
      
      let response;
      if (tipo === 'clase') {
        response = await axios.post(`${API}/api/clases/marcar-asistencia-qr`, {
          clase_id: id
        });
      } else if (tipo === 'evento') {
        response = await axios.post(`${API}/api/eventos/marcar-asistencia-qr`, {
          evento_id: id
        });
      } else {
        throw new Error('Código QR no válido. Formato esperado: "tipo|id" o URL válida');
      }
      
      console.log('✅ Respuesta del servidor:', response.data);
      
      setScanResult({
        success: true,
        tipo: tipo === 'clase' ? 'Clase' : 'Evento',
        titulo: response.data.clase_titulo || response.data.evento_titulo,
        mensaje: response.data.message
      });
      
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
      
      await cargarHistorialHoy();
      
    } catch (error) {
      console.error('❌ Error procesando QR:', error);
      console.error('❌ Datos del QR:', qrData);
      console.error('❌ Response:', error.response?.data);
      
      let errorMessage = 'Error al marcar asistencia';
      
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      // Si falla como clase, intentar como evento
      if (tipo === 'clase' && !qrData.includes('|') && !qrData.includes('/')) {
        console.log('Falló como clase, intentando como evento...');
        try {
          const response = await axios.post(`${API}/api/eventos/marcar-asistencia-qr`, {
            evento_id: id
          });
          
          setScanResult({
            success: true,
            tipo: 'Evento',
            titulo: response.data.evento_titulo,
            mensaje: response.data.message
          });
          
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 3000);
          await cargarHistorialHoy();
          setLoading(false);
          return;
        } catch (e) {
          console.error('También falló como evento');
        }
      }
      
      setScanResult({
        success: false,
        mensaje: errorMessage + '\n\nDatos QR: ' + qrData
      });
    } finally {
      setLoading(false);
    }
  };

  const reiniciarScanner = () => {
    setScanResult(null);
    setCameraError(null);
    setFotoCaptured(null);
    iniciarScanner();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-block">
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-3 rounded-2xl shadow-lg mb-4">
              <h1 className="text-3xl font-bold flex items-center gap-3">
                <i className="fas fa-qrcode animate-pulse"></i>
                Scan Presencia
              </h1>
            </div>
          </div>
          <p className="text-gray-600 text-lg">Escanea el código QR para marcar tu asistencia</p>
        </div>

        {/* Main Scanner Card */}
        <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 mb-6 border border-white/50">
          {!scanning && !scanResult && !cameraError && (
            <div className="text-center py-12">
              <div className="mb-6">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center shadow-xl animate-bounce">
                  <i className="fas fa-camera text-white text-6xl"></i>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                ¿Listo para marcar asistencia?
              </h2>
              <p className="text-gray-600 mb-6">
                Activa la cámara, apunta al QR y toma una foto
              </p>
              <button
                onClick={iniciarScanner}
                className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                <i className="fas fa-camera mr-3"></i>
                Activar Cámara
              </button>
            </div>
          )}

          {cameraError && (
            <div className="text-center py-12">
              <div className="w-24 h-24 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl">
                <i className="fas fa-exclamation-triangle text-white text-5xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-red-600 mb-3">
                Error de Cámara
              </h3>
              <p className="text-red-700 mb-6">{cameraError}</p>
              <button
                onClick={reiniciarScanner}
                className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all"
              >
                <i className="fas fa-redo mr-2"></i>
                Intentar Nuevamente
              </button>
            </div>
          )}

          {scanning && !scanResult && !fotoCaptured && (
            <div>
              <div className="mb-4 text-center">
                <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full">
                  <i className="fas fa-camera text-green-600"></i>
                  <span className="font-semibold">Cámara lista - Apunta al QR y toma la foto</span>
                </div>
              </div>
              
              {/* Video Container */}
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl blur-xl opacity-50"></div>
                <div className="relative bg-black rounded-2xl overflow-hidden">
                  <video 
                    ref={videoRef} 
                    className="w-full h-auto"
                    playsInline
                    muted
                  />
                  <canvas ref={canvasRef} className="hidden" />
                  
                  {/* Overlay con marco de escaneo */}
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="relative w-64 h-64">
                      {/* Marco principal */}
                      <div className="absolute inset-0 border-4 border-white rounded-2xl shadow-2xl"></div>
                      
                      {/* Esquinas */}
                      <div className="absolute top-0 left-0 w-12 h-12">
                        <div className="absolute top-0 left-0 w-full h-1 bg-green-400"></div>
                        <div className="absolute top-0 left-0 w-1 h-full bg-green-400"></div>
                      </div>
                      <div className="absolute top-0 right-0 w-12 h-12">
                        <div className="absolute top-0 right-0 w-full h-1 bg-green-400"></div>
                        <div className="absolute top-0 right-0 w-1 h-full bg-green-400"></div>
                      </div>
                      <div className="absolute bottom-0 left-0 w-12 h-12">
                        <div className="absolute bottom-0 left-0 w-full h-1 bg-green-400"></div>
                        <div className="absolute bottom-0 left-0 w-1 h-full bg-green-400"></div>
                      </div>
                      <div className="absolute bottom-0 right-0 w-12 h-12">
                        <div className="absolute bottom-0 right-0 w-full h-1 bg-green-400"></div>
                        <div className="absolute bottom-0 right-0 w-1 h-full bg-green-400"></div>
                      </div>
                    </div>
                    
                    {/* Instrucción */}
                    <div className="absolute bottom-4 left-0 right-0 text-center">
                      <div className="inline-block bg-black/70 text-white px-4 py-2 rounded-full text-sm">
                        📱 Coloca el QR dentro del marco
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex gap-3 justify-center">
                <button
                  onClick={capturarFoto}
                  className="bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all flex items-center gap-3"
                >
                  <i className="fas fa-camera text-2xl"></i>
                  Capturar Foto del QR
                </button>
                
                <button
                  onClick={detenerScanner}
                  className="bg-red-500 text-white px-6 py-4 rounded-xl font-semibold shadow-lg hover:bg-red-600 transition-all"
                >
                  <i className="fas fa-times mr-2"></i>
                  Cancelar
                </button>
              </div>
            </div>
          )}

          {fotoCaptured && loading && (
            <div className="text-center py-8">
              <div className="mb-6">
                <img src={fotoCaptured} alt="Foto capturada" className="max-w-md mx-auto rounded-xl shadow-lg" />
              </div>
              <div className="inline-block">
                <div className="w-20 h-20 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-gray-600 font-semibold">🔍 Buscando código QR en la foto...</p>
              </div>
            </div>
          )}

          {scanResult && (
            <div className="text-center py-8">
              {scanResult.success ? (
                <div className="relative">
                  {showSuccess && (
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="text-9xl animate-ping opacity-50">✓</div>
                    </div>
                  )}
                  <div className="relative z-10">
                    <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl animate-bounce">
                      <i className="fas fa-check text-white text-5xl"></i>
                    </div>
                    <h3 className="text-3xl font-bold text-green-600 mb-3">
                      ¡Asistencia Confirmada!
                    </h3>
                    <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-6">
                      <p className="text-lg font-semibold text-gray-800 mb-2">
                        {scanResult.tipo}: {scanResult.titulo}
                      </p>
                      <p className="text-green-700">{scanResult.mensaje}</p>
                    </div>
                    <button
                      onClick={reiniciarScanner}
                      className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all"
                    >
                      <i className="fas fa-qrcode mr-2"></i>
                      Escanear Otro Código
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="w-24 h-24 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl">
                    <i className="fas fa-times text-white text-5xl"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-red-600 mb-3">
                    Error
                  </h3>
                  <div className="bg-red-50 border-2 border-red-200 rounded-xl p-6 mb-6">
                    <p className="text-red-700">{scanResult.mensaje}</p>
                  </div>
                  <button
                    onClick={reiniciarScanner}
                    className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all"
                  >
                    <i className="fas fa-redo mr-2"></i>
                    Intentar Nuevamente
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Historial del Día */}
        <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-6 border border-white/50">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-3">
            <i className="fas fa-history text-indigo-600"></i>
            Asistencias de Hoy
          </h2>
          
          {historial.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <i className="fas fa-calendar-day text-5xl mb-3 opacity-50"></i>
              <p>Aún no has marcado asistencia hoy</p>
            </div>
          ) : (
            <div className="space-y-3">
              {historial.map((item, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-r from-indigo-50 to-purple-50 border-l-4 border-indigo-500 p-4 rounded-lg hover:shadow-md transition-all"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center">
                        <i className={`fas ${item.clase_id ? 'fa-book' : 'fa-calendar-alt'} text-white`}></i>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800">
                          {item.clase_titulo || item.evento_titulo || 'Asistencia'}
                        </p>
                        <p className="text-sm text-gray-600">
                          {new Date(item.fecha).toLocaleTimeString('es-UY', { 
                            hour: '2-digit', 
                            minute: '2-digit' 
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="text-green-600">
                      <i className="fas fa-check-circle text-2xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Info Card */}
        <div className="mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-6">
          <div className="flex items-start gap-4">
            <i className="fas fa-info-circle text-blue-600 text-2xl mt-1"></i>
            <div>
              <h3 className="font-bold text-blue-900 mb-2">¿Cómo funciona?</h3>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• El profesor muestra un código QR en clase o evento</li>
                <li>• Presiona "Activar Cámara"</li>
                <li>• Apunta tu cámara al código QR</li>
                <li>• Presiona "Capturar Foto del QR"</li>
                <li>• ¡Tu asistencia se registrará automáticamente!</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanPresencia;
